import React from 'react';
import { H3 } from 'ds/components/typography';
import { useLocale } from 'locale';
import GoodNewsIcon from 'assets/svg/good-news-stars.svg';
import { ShowAt } from 'consts/breakpoints';

import {
  NoConstructionsWrapper,
  NoConstructionsIconWrapper,
  NoConstructionsHeader,
  NoConstructionsText,
} from './styled';

interface NoConstructionsBlockProps {
  isCommercial: boolean;
}

export const NoConstructionsBlock: React.FC<NoConstructionsBlockProps> = ({ isCommercial }) => {
  const { t } = useLocale();
  return (
    <NoConstructionsWrapper>
      <NoConstructionsIconWrapper>
        <GoodNewsIcon />
      </NoConstructionsIconWrapper>
      <ShowAt to={2}>
        <NoConstructionsHeader>{t('unitPage.noConstructionsHeader')}</NoConstructionsHeader>
        <NoConstructionsText>{t('unitPage.noConstructionsText', { isCommercial })}</NoConstructionsText>
      </ShowAt>
      <ShowAt from={3}>
        <H3>{t('unitPage.noConstructionsHeader')} {t('unitPage.noConstructionsText', { isCommercial })}</H3>
      </ShowAt>
    </NoConstructionsWrapper>
  );
};
